/**
 * Timing constants for the application
 * Centralized timing values for consistency and easy maintenance
 */

// Loading and UI delays
export const LOADING_DELAY_MS = 500;
export const SKELETON_DISPLAY_MS = 2000;

// Cache and stale times for React Query
export const CACHE_TIME_MS = 5 * 60 * 1000; // 5 minutes
export const LONG_CACHE_TIME_MS = 30 * 60 * 1000; // 30 minutes
export const SHORT_CACHE_TIME_MS = 1 * 60 * 1000; // 1 minute

// Session and booking
export const SESSION_DURATION_MINUTES = 60;
export const BOOKING_REFRESH_INTERVAL_MS = 30 * 1000; // 30 seconds
export const CHECK_IN_WINDOW_MS = 30 * 60 * 1000; // 30 minutes before start time

// Matches the "2 hour" booking reminder push notification (api/src/jobs/booking-reminders.job.ts)
export const CALENDAR_ALERT_MINUTES_BEFORE = 120;

// Animation durations (matching CSS)
export const DIALOG_ANIMATION_MS = 300;
export const DRAWER_ANIMATION_MS = 300;
export const TOAST_DURATION_MS = 3000;

// Debounce delays
export const SEARCH_DEBOUNCE_MS = 300;
export const INPUT_DEBOUNCE_MS = 500;
